import { CollectionItem } from '../../secure-json/core/secure-json-collection/types';
import { CollectionName, SerializedCollection } from '../types';

export type SyncCollection = {
  collectionName: CollectionName;
  collection: SerializedCollection;
};

export enum SyncQueueJobMethod {
  SINGLE_PUSH = 'SINGLE_PUSH',
  // PULL = 'PULL',
  SINGLE_PULL = 'SINGLE_PULL',
  ADD_ITEM = 'ADD_ITEM',
  CHANGE_ITEM = 'CHANGE_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
}

type JobAddItem = {
  method: SyncQueueJobMethod.ADD_ITEM;
  collectionName: CollectionName;
  item: CollectionItem;
};
type JobChangeItem = {
  method: SyncQueueJobMethod.CHANGE_ITEM;
  collectionName: CollectionName;
  item: CollectionItem;
};
type JobRemoveItem = {
  method: SyncQueueJobMethod.REMOVE_ITEM;
  collectionName: CollectionName;
  item: CollectionItem;
};

export type AddJobProps = JobAddItem | JobChangeItem | JobRemoveItem;
